export const getErrorByStatusCode = (error, statusCode) => {
  const { graphQLErrors } = error;
  if (!graphQLErrors.length) return graphQLErrors;

  const errorsByStatusCode = graphQLErrors
    .filter(err => err.extensions.status_code === statusCode)
    .flat();

  if (!errorsByStatusCode.length) {
    return undefined;
  }

  return errorsByStatusCode;
};
